export enum STRIPE_ACCOUNT_STATUS {
  "IN_PROGRESS" = "IN_PROGRESS",
  "SUCCESSFUL" = "SUCCESSFUL",
  "FAILURE" = "FAILURE",
}
export enum STRIPE_PAYMENT_STATUS {
  "IN_PROGRESS" = "IN_PROGRESS",
  "SUCCESSFUL" = "SUCCESSFUL",
  "FAILURE" = "FAILURE",
}

export enum FIREBASE_COLLECTIONS {
  gigs = "gigs",
  proposals = "proposals",
  users = "users",
  transactions = "transactions",
}

export enum PAYMENT_REASON {
  CHEF_BOOKING = "CHEF_BOOKING",
  SELECT_PROPOSAL = "SELECT_PROPOSAL",
  GIG_COMPLETION = "GIG_COMPLETION",
}

export enum CAPTURE_TYPE {
  uncaptured = "uncaptured",
  captured = "captured",
}

export enum BUSINESS_TYPE {
  INDIVIDUAL = "individual",
  COMPANY = "company",
}
